
export default {
    name: 'CrowdfundTestimonials',
    data() {
        return {
            testimonials: [
                {
                    rating: 5,
                    user: 'TD9631',
                    date: '07/07/2019',
                    title: 'Highly recommend',
                    review: 'I’m so happy an app like this finally exists! It makes the whole process really easy.',
                },
                {
                    rating: 5,
                    user: 'Welch Charlie5',
                    date: '24/07/2020',
                    title: 'Everyone should download this app!',
                    review: 'Good simple functionality and a rapid response to the issues the app is designed to raise.',
                },
                {
                    rating: 5,
                    user: 'Robert.123p',
                    date: '25/07/2020',
                    title: 'Useful and effective',
                    review: 'Easy to use and stuff does get cleared / sorted within a few days. Well done.',
                },
                {
                    rating: 5,
                    user: 'Mburtsygseh',
                    date: '05/07/2019',
                    title: 'Superb app for a much needed problem',
                    review: 'Fly tipping is a major issue and this solves it and makes it an easy and enjoyable process as well.',
                },
            ],
        };
    },
};
